Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Share = Marionette.Behavior.extend({
        ui: {
            socialButton: '.social_button'
        },
        events: {
            'click @ui.socialButton': 'onShare',
            'keydown @ui.socialButton': 'onHandleKeyboard'
        },
        onHandleKeyboard: function(e) {
            // enter
            if (e.keyCode === 13) {
                e.preventDefault();
                e.target.click();
            }
        },
        onShare: function(ev) {
            var currentTarget = $(ev.currentTarget);
            var socialNetworkName;

            if (currentTarget.hasClass('pixlee_fshare')) {
                socialNetworkName = 'facebook';
            } else if (currentTarget.hasClass('pixlee_tweet')) {
                socialNetworkName = 'twitter';
            } else if (currentTarget.hasClass('pixlee_pinit')) {
                socialNetworkName = 'pinterest';
            } else if (currentTarget.hasClass('pixlee_tumblr')) {
                socialNetworkName = 'tumblr';
            }

            App.commands.execute('photo:shared', this.view.model.get('album_photo_id'), socialNetworkName);

            var productInfo = _.map(this.view.model.get('products'), function(product) {
                return {
                    name: App.request('decode:utf8', product.title),
                    sku: product.sku,
                    imageUrl: App.request('decode:utf8', product.image),
                    linkUrl: App.request('decode:utf8', product.link),
                };
            });


            var sharingData = {
                name: 'pixlee:social:share',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    socialNetwork: socialNetworkName,
                    products: productInfo
                }
            };

            window.parent.postMessage(JSON.stringify(sharingData), '*');

            // Send a message to the parent asking for the full URL of the page which is relayed back to the widget
            // at public/javascripts/backbone/lib/concerns/views/social_share_helpers.js to be shared to social media
            var data = {
                name: 'pixlee:share:to:social',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    photoJson: this.view.model.toJSON(),
                    source: socialNetworkName,
                }
            };

            window.parent.postMessage(JSON.stringify(data), '*');
        },
    });

});
